export const FILE_SIZE = 1024 * 5;
export const SUPPORTED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png'];
